import React from 'react';
import { Sprout, Trophy, Clock } from 'lucide-react';
export function KidsAgeGroups() {
  return <section className="py-24 bg-paper border-b border-subtle-gray" data-id="element-1845">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1846">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-1847">
          <div className="inline-flex items-center gap-2 bg-storm-red/10 text-storm-red px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-1848">
            Two Age Groups
          </div>
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1849">
            Kids Taekwondo Classes for Ages 3+
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-1850">
            Parents in Farmington Hills, Commerce, Walled Lake, Wixom and Novi
            tell us they're looking for one thing: a program that teaches real
            self-defense awareness while building the grit, focus, and mental
            toughness their kids will use for life. Storm Taekwondo is built
            around exactly that.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-1851">
          <div className="bg-off-white border border-subtle-gray rounded-2xl p-8 flex flex-col gap-4" data-id="element-1852">
            <div className="flex items-center gap-3" data-id="element-1853">
              <div className="w-12 h-12 rounded-xl bg-storm-red/10 flex items-center justify-center text-storm-red" data-id="element-1854">
                <Sprout className="w-6 h-6" data-id="element-1855" />
              </div>
              <div data-id="element-1856">
                <p className="text-xs uppercase tracking-wide text-gray-warm font-bold" data-id="element-1857">
                  Ages 3 — 5
                </p>
                <h3 className="text-2xl text-ink leading-tight" data-id="element-1858">
                  Mini Troopers
                </h3>
              </div>
            </div>
            <p className="text-gray-warm leading-relaxed" data-id="element-1859">
              Preschool-friendly classes that build listening skills,
              coordination, and confidence. Short, structured, high-energy
              sessions designed for little legs and short attention spans.
            </p>
            <p className="text-sm text-ink font-bold" data-id="element-1860">
              <Clock className="w-4 h-4 inline mr-1 text-storm-red" data-id="element-1861" />
              Monday–Friday · 4:30–5:00 PM
            </p>
          </div>

          <div className="bg-off-white border border-subtle-gray rounded-2xl p-8 flex flex-col gap-4" data-id="element-1862">
            <div className="flex items-center gap-3" data-id="element-1863">
              <div className="w-12 h-12 rounded-xl bg-storm-red/10 flex items-center justify-center text-storm-red" data-id="element-1864">
                <Trophy className="w-6 h-6" data-id="element-1865" />
              </div>
              <div data-id="element-1866">
                <p className="text-xs uppercase tracking-wide text-gray-warm font-bold" data-id="element-1867">
                  Ages 6+
                </p>
                <h3 className="text-2xl text-ink leading-tight" data-id="element-1868">
                  Kids Taekwondo / Storm Troopers
                </h3>
              </div>
            </div>
            <p className="text-gray-warm leading-relaxed" data-id="element-1869">
              Full Taekwondo training — kicks, forms, sparring, belt progression
              — taught in a positive coaching environment that builds
              confidence, respect, and real martial arts skill.
            </p>
            <p className="text-sm text-ink font-bold" data-id="element-1870">
              <Clock className="w-4 h-4 inline mr-1 text-storm-red" data-id="element-1871" />
              Monday–Friday · 5:00–6:00 PM and 6:00–7:00 PM
            </p>
          </div>
        </div>

        <p className="text-center text-gray-warm text-sm mt-10 max-w-2xl mx-auto" data-id="element-1872">
          <span className="font-bold text-ink" data-id="element-1873">A quick note:</span> some parents
          search for &ldquo;kids karate&rdquo; when they're really looking for
          any structured martial art. Storm teaches Taekwondo (Olympic-style, WT
          / Kukkiwon aligned) — not karate — but the confidence, discipline, and
          skill-building benefits parents care about are exactly the same.
        </p>
      </div>
    </section>;
}